import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedDefaultChannelVisited } from 'reducers/KBQ/selectedChannelVisited'
import { getSelectedDefaultKBQChannelVisited } from 'reducers/KBQ/selector'
import { RootState } from 'reducers/store'

export const RESEARCH_CHANNEL_GROUP = 'researchChannelGroup'
export const RESEARCH_CHANNEL_VARIABLEID = 43
export enum ResearchChannelCodes {
  RESEARCH_ONLINE = 99990,
  RESEARCH_OFFLINE = 99991,
  RESEARCH_ONLINE_OFFLINE = 99992,
}
export enum ResearchChannelLabels {
  RESEARCH_ONLINE = 'Online',
  RESEARCH_OFFLINE = 'In-store',
  RESEARCH_ONLINE_OFFLINE = 'Total',
}
export enum RetailLostShopperTypes {
  RETAILER_LOST_SHOPPER_INSTORE = 764,
  RETAILER_LOST_SHOPPER_ONLINE = 765,
  TOTAL_RETAILER_LOST_SHOPPER = 763,
}
export enum RetailVisitorsTypes {
  VISITED_RETAILER_ONLINE = 756,
  VISITED_RETAILER_IN_STORE = 755,
  VISITOR_RETAILER_TOTAL_VISITED = 757,
}
export enum Suffix {
  Visits = 'visits',
}

export const useSelectedVisitors = () => {
  const dispatch = useDispatch()
  const pathName = window.location.pathname.split('/').pop()
  const visitorChannelOptions = useMemo(
    () => [
      {
        label: 'Online visits',
        answer_id: 99990,
        answer_code: 99990,
      },
      {
        label: 'In-store visits',
        answer_id: 99991,
        answer_code: 99991,
      },
      {
        label: 'Total visits',
        answer_id: 99992,
        answer_code: 99992,
      },
    ],
    []
  )
  const defaultChannelSelectedLabel = useSelector((state: RootState) =>
    getSelectedDefaultKBQChannelVisited(state, { id: pathName! })
  )?.defaultChannel

  useEffect(() => {
    if (visitorChannelOptions.length > 0 && !defaultChannelSelectedLabel)
      dispatch(
        setSelectedDefaultChannelVisited({
          id: pathName!,
          defaultChannel: visitorChannelOptions[2],
        })
      )
  }, [dispatch, pathName, visitorChannelOptions, defaultChannelSelectedLabel])
  return {
    defaultResearchChannel: visitorChannelOptions[2],
    channelVisitedOptions: visitorChannelOptions,
  }
}
